import { AxiosError } from 'axios';
import { isErrorContainingKey } from 'app-shared/lib/api/utils/axios-request.utils';
import {
  ANONYMOUS_PRINCIPALS,
  DEFAULT_RESERVATION_ERROR_MESSAGE,
  RESERVATION_ERROR_MESSAGES,
} from './reservation.constants';
import { Reservation } from './reservation.interface';

export const getReservationErrorKey = (error: AxiosError): string | null => {
  const matchingKey = Object.keys(RESERVATION_ERROR_MESSAGES).find((key) => isErrorContainingKey(error, key));

  return matchingKey || null;
};

export const getReservationErrorMessage = (error: AxiosError): string => {
  const errorKey = getReservationErrorKey(error);
  const message = (errorKey && RESERVATION_ERROR_MESSAGES[errorKey]) || DEFAULT_RESERVATION_ERROR_MESSAGE;

  return message;
};

export const isReservationAwaitingReconfirmation = (reservation: Reservation): boolean => {
  const isAwaiting = reservation.reconfirmationRequestedDate != null && reservation.reconfirmedDate == null;

  return isAwaiting;
};

export const isReservationBookedByShop = (reservation: Reservation): boolean => {
  const creator = (reservation.createdBy || '').trim();
  const guestUid = (reservation.userUid || '').trim();
  const isBookedByShop = creator !== '' && !ANONYMOUS_PRINCIPALS.includes(creator) && creator !== guestUid;

  return isBookedByShop;
};

export const isReservationSeatHolding = (reservation: Reservation): boolean => {
  const seatHoldingStatuses = ['REQUESTED', 'CONFIRMED', 'SEATED'];
  const isSeatHolding = seatHoldingStatuses.includes(reservation.status);

  return isSeatHolding;
};

export const replaceReservation = (reservations: Reservation[], updatedReservation: Reservation): Reservation[] => {
  const replacedReservations = reservations.map((reservation) => {
    if (reservation.id === updatedReservation.id) return updatedReservation;

    return reservation;
  });

  return replacedReservations;
};
